/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum CalculationResultStatus {
    Ok = 'Ok',
    OkWithWarning = 'OkWithWarning',
    Error = 'Error'
  }

    export const CalculationResultStatusTranslocoMap: Record<CalculationResultStatus, string> = {
    [CalculationResultStatus.Ok]: 'calculationResultStatus.ok',
    [CalculationResultStatus.OkWithWarning]: 'calculationResultStatus.okWithWarning',
    [CalculationResultStatus.Error]: 'calculationResultStatus.error',
    };

    export const CalculationResultStatusOptions = [
  { value: CalculationResultStatus.Ok, labelKey: 'calculationResultStatus.ok' },
  { value: CalculationResultStatus.OkWithWarning, labelKey: 'calculationResultStatus.okWithWarning' },
  { value: CalculationResultStatus.Error, labelKey: 'calculationResultStatus.error' },
    ];

